module.exports = __webpack_public_path__ + "img/icon_1_41.110b66f6.png";